import React from 'react';

import { GetProviderScoreHistoryQuery, WeeklyProviderScore } from '../types';
import useGetProviderScoreHistory from './useGetProviderScoreHistory';

// snapshot_date is a plain YYYY-MM-DD; parsing as UTC keeps the local timezone from shifting the week
const weekStartOf = (snapshotDate: string) => {
    const date = new Date(`${snapshotDate}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));

    return date.toISOString().slice(0, 10);
};

/**
 * Scores are snapshotted daily, but the other charts on this page are weekly, so 90 daily points
 * would neither fit the axis nor line up with them. Each snapshot already covers a trailing 90-day
 * window, so the last snapshot of a week represents that week; consecutive weeks still overlap
 * heavily in the underlying data.
 */
const useGetProviderScoreWeeks = (query?: GetProviderScoreHistoryQuery) => {
    const { data } = useGetProviderScoreHistory(query);

    return React.useMemo(() => {
        if (!data) {
            return undefined;
        }

        const chronological = [...data.provider_scores].sort((a, b) =>
            a.snapshot_date.localeCompare(b.snapshot_date)
        );

        // last write per week wins, and Map keeps each week at its first-insertion position
        const latestPerWeek = new Map<string, WeeklyProviderScore>();

        for (const snapshot of chronological) {
            const week_start = weekStartOf(snapshot.snapshot_date);
            latestPerWeek.set(week_start, { ...snapshot, week_start });
        }

        return [...latestPerWeek.values()];
    }, [data]);
};

export default useGetProviderScoreWeeks;
